import { createFileRoute } from "@tanstack/react-router";
import { DashboardShell } from "@/components/DashboardShell";
import { SUPER_ADMIN_NAV } from "@/lib/nav";
import { NotificationCenter } from "@/components/NotificationCenter";

export const Route = createFileRoute("/_authenticated/super-admin/notifications")({
  head: () => ({
    meta: [
      { title: "Notifications · Landoo Super Admin" },
      {
        name: "description",
        content: "System-wide notifications and platform events for Landoo super admins.",
      },
      { property: "og:title", content: "Notifications · Landoo Super Admin" },
      {
        property: "og:description",
        content: "System-wide notifications and platform events for Landoo super admins.",
      },
    ],
  }),
  component: () => (
    <DashboardShell title="Notifications" role="Super Admin" items={SUPER_ADMIN_NAV}>
      <NotificationCenter />
    </DashboardShell>
  ),
});
